import React from 'react';
import { Tooltip, TooltipPlacement } from '../../../../components/atoms/Tooltip';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import useCollapsibleOverlay from '../../../../hooks/useCollapsibleOverlay';
import { CollapsibleContentSpan } from '../../../../components/organisms/CollapsibleOverlay/CollapsibleOverlay';
import { CollapsibleModifier } from '../../../../components/organisms/CollapsibleOverlay/CollapsibleOverlay.modifier';

export type Help = {
  id: string;
  helpText: string;
  helpTextPlacement?: 'bottom-right' | 'right-center';
  tooltipPlacement?: TooltipPlacement;
};

/**
 * Renders a button in a Label with an Tooltip and a Collapsible with the HelpText inside.
 */
export function Help({ id, helpText, helpTextPlacement, tooltipPlacement = TooltipPlacement.RIGHT }: Help) {
  const { t } = useSonTranslation('FormHelp');
  const { toggleProps, collapsibleProps, collapsibleOpen } = useCollapsibleOverlay();

  const getHelpTextPlacement = () => {
    switch (helpTextPlacement) {
      case 'bottom-right':
        return CollapsibleModifier.FORM_HELP_BOTTOM_RIGHT;
      case 'right-center':
        return CollapsibleModifier.FORM_HELP_RIGHT_CENTER;
      default:
        return CollapsibleModifier.FORM_HELP;
    }
  };

  return (
    <span id={id} className="help">
      <span className="help__text-container">
        <Tooltip attachTo={toggleProps.ref} placement={tooltipPlacement} hideOnClick>
          <button
            type="button"
            className="help__button font-bold-15-15"
            title={t('help')}
            aria-label={t('help')}
            {...toggleProps}
          >
            <span aria-hidden="true">?</span>
          </button>
        </Tooltip>
        <CollapsibleContentSpan {...collapsibleProps} modifier={getHelpTextPlacement()}>
          {collapsibleOpen && <span className="help__text">{helpText}</span>}
        </CollapsibleContentSpan>
      </span>
    </span>
  );
}
